export const rubros = [
	{

		"nombre": "1. Normatividad",
		"icono": "Normatividad.png",
		"formatos": [
			{
				"nombre": "Marco Normativo",
				"xlsx": "a69_f01Estatal",
				"html": "a69_f01Estatal"
			}
		]
	},
	{

		"nombre": "2. Estructura",
		"icono": "Estructura.png",
		"formatos": [
			{
				"nombre": "Estructura Orgánica",
				"xlsx": "a69_f02_a",
				"html": "a69_f02_a"
			},
			{
				"nombre": "Organigrama",
				"xlsx": "a69_f02_b",
				"html": "a69_f02_b"
			}
		]
	},
	{

		"nombre": "3. Facultades",
		"icono": "Facultades.png",
		"formatos": [
			{
				"nombre": "Facultades",
				"xlsx": "a69_f03",
				"html": "a69_f03"
			}
		]
	},
	{

		"nombre": "4. Programas Operativos Anuales",
		"icono": "ProgramasOperativosAnuales.png",
		"formatos": [
			{
				"nombre": "Metas y Objetivos",
				"xlsx": "a69_f04",
				"html": "a69_f04"
			}
		]

	},
	{

		"nombre": "5. Indicadores de Interés",
		"icono": "IndicadoresInteres.png",
		"formatos": [
			{
				"nombre": "Indicadores de Interés",
				"xlsx": "a69_f5",
				"html": "a69_f5"
			}
		]

	},
	{

		"nombre": "6. Matriz de Indicadores",
		"icono": "MatrizIndicadores.png",
		"formatos": [
			{
				"nombre": "Matriz de Indicadores",
				"xlsx": "a69_f6",
				"html": "a69_f6"
			}
		]

	},
	{

		"nombre": "7. Directorio",
		"icono": "Directorio.png",
		"formatos": [
			{
				"nombre": "Directorio",
				"xlsx": "a69_f7",
				"html": "a69_f7"
			}
		]

	},
	{

		"nombre": "8. Sueldos",
		"icono": "Sueldos.png",
		"formatos": [
			{
				"nombre": "Remuneraciones",
				"xlsx": "a69_f8_a",
				"html": "a69_f8_a"
			},
			{
				"nombre": "Tabulador de Sueldos y Salarios",
				"xlsx": "a69_f8_b",
				"html": "a69_f8_b"
			}
		]

	},
	{

		"nombre": "9. Viáticos",
		"icono": "Viaticos.png",
		"formatos": [
			{
				"nombre": "Viáticos",
				"xlsx": "a69_f9",
				"html": "a69_f9"
			}
		]
	},
	{

		"nombre": "10. Plazas",
		"icono": "Plazas.png", "formatos": [
			{
				"nombre": "Total de Personal de Base y Confianza",
				"xlsx": "a69_f10_a",
				"html": "a69_f10_a"
			},
			{
				"nombre": "Total de las Plazas de Base y Confianza",
				"xlsx": "a69_f10_b",
				"html": "a69_f10_b"
			}
		]
	},
	{

		"nombre": "11. Honorarios",
		"icono": "Honorarios.png",
		"formatos": [
			{
				"nombre": "Personal de Honorarios",
				"xlsx": "a69_f11",
				"html": "a69_f11"
			}
		]
	},
	{
		"nombre": "12. Declaraciones Públicas",
		"icono": "DeclaracionesPublicas.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			}
			
		],
		"url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%BAblicas"
	},
	{
		"nombre": "13. Datos de Contacto de la Unidad",
		"icono": "DatosContactoUnidad.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": "",

				
			
				
			}
		],
		 "url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad"
	},  

	{

		"nombre": "14. Convocatorias",
		"icono": "Convocatorias.png",
		"formatos": [
			{
				"nombre": "Convocatorias a Concursos para Cargos Públicos",
				"xlsx": "a69_f14",
				"html": "a69_f14"
			}
		]
	},
	{

		"nombre": "15. Programas Sociales",
		"icono": "ProgramasSociales.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			},
		],
		"url": "https://sebiso.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/15%20-%20Programas%20Sociales"
	},
	{

		"nombre": "16. Relaciones Laborales",
		"icono": "RelacionesLaborales.png",
		"formatos": [
			{
				"nombre": "Condiciones Generales de Trabajo",
				"xlsx": "a69_f16_a",
				"html": "a69_f16_a"
			},
			{
				"nombre": "Recursos Públicos",
				"xlsx": "a69_f16_b",
				"html": "a69_f16_b"
			}
		]
	},
	{

		"nombre": "17. Información Curricular",
		"icono": "InformacionCurricular.png",
		"formatos": [
			{
				"nombre": "Información Curricular",
				"xlsx": "a69_f17",
				"html": "a69_f17"
			}
		]
	},
	{
		"nombre": "18. Sanciones Administrativas",
		"icono": "SancionesAdministrativas.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": "",
			}
		],
		"url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas"
	},
	{
		"nombre": "19. Servicios",
		"icono": "Servicios.png",
		"formatos": [
			{
				"nombre": "Servicios",
				"xlsx": "a69_f19",
				"html": "a69_f19"
			}
		]

	},
	{

		"nombre": "20. Trámites",
		"icono": "Tramites.png",
		"formatos": [
			{
				"nombre": "Trámites",
				"xlsx": "a69_f20",
				"html": "a69_f20"
			}
		]

	},
	{

		"nombre": "21. Presupuesto e Informes Trimestrales",
		"icono": "PresupuestoInformesTrimestrales.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			},
		],
		"url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/21.Presupuesto%20e%20Informes%20Trimestrales"
	},
	{

		"nombre": "22. Deuda Pública",
		"icono": "DeudaPublica.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": "",
			}
		],
		"url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%BAblica"
	},
	{

		"nombre": "23. Comunicación Social y Publicidad",
		"icono": "ComunicacionSocialPublicidad.png",
		"formatos": [
			{
				"nombre": "Programa Anual de Comunicación Social",
				"xlsx": "a69_f23_a",
				"html": "a69_f23_a"
			},
			{
				"nombre": "Erogación de Recursos de Comunicación Social",
				"xlsx": "a69_f23_b",
				"html": "a69_f23_b"
			},
			{
				"nombre": "Tiempos Oficiales",
				"xlsx": "a69_f23_c",
				"html": "a69_f23_c",

				"xlsx_liga" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx",
				"htm_liga" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm"
			},
			/* {
				"nombre": "Información Relacionada a Tiempos Oficiales",
				"xlsx": "a69_f23_d",
				"html": "a69_f23_d",
				"xlsx_liga" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2023/Transparencia/xlsx/a69_f23_d_RTVH.xlsx",
				"htm_liga" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2023/Transparencia/htm/a69_f23_d_RTVH.htm"
			} */
		]
	},
	
	{

		"nombre": "24. Resultados de Auditorías",
		"icono": "ResultadosAuditorias.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": "",
				
			}
		],
		"url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%ADas"
	},
	{

		"nombre": "25. Dictámines de Estados Financiero ",
		"icono": "DictamenesFinancieros.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": "",
				
			}
		],
		"url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/25.Dict%C3%A1menes%20de%20Estados%20Financieros"

	},
	{

		"nombre": "26. Asignación de Recursos Públicos a Personas",
		"icono": "AsignacionRecursosPublicosPersonas.png",
		"formatos": [
			{
				"nombre": "Personas a Quienes se asignó Recursos Públcios",
				"xlsx": "a69_f26",
				"html": "a69_f26"
			}
		]

	},
	{

		"nombre": "27.  Concesiones",
		"icono": "Concesiones.png",
		"formatos": [
			{
				"nombre": "Concesiones, Contratos, Convenios, Permisos, Licencias y Autorizaciones",
				"xlsx": "a69_f27",
				"html": "a69_f27"
			}
		]

	},
	{

		"nombre": "28. Licitaciones Públicas",
		"icono": "LicitacionesPublicas.png",
		"formatos": [
			{
				"nombre": "Procedimientos de Adjudicación Directa, Licitación Pública e Invitación Restringida",
				"xlsx": "2024_a69_f28",
				"html": "2024_a69_f28"
			},
			/* {
				"nombre": "Procedimientos de Adjudicación Directa",
				"xlsx": "f28_b",
				"html": "f28_b"
			} */
		]

	},
	{

		"nombre": "29. Informes",
		"icono": "Informes.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": "",
				
			}
		],
		"url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/29.%20Informes"

	},
	{

		"nombre": "30. Estadísticas Generadas",
		"icono": "EstadisticasGenerales.png",
		"formatos": [
			{
				"nombre": "Estadísticas",
				"xlsx": "a69_f30",
				"html": "a69_f30"
			}
		]

	},
	{

		"nombre": "31. Informe de Avances y Documentos Financiero",
		"icono": "InformeAvancesDocumentosFinancieros.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			},
			
		],
		"url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/31.Informe%20de%20Avances%20y%20Documentos%20Financieros"
	},
	{

		"nombre": "32. Padrón de Proveedores y Contratistas",
		"icono": "PadronProveedoresContratistas.png",
		"formatos": [
			{
				"nombre": " ",
				"xlsx": "",
				"html": "",
				
			}
		],
		"url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas"

	},
	{

		"nombre": "33. Convenios con Sectores Social y Privado",
		"icono": "ConveniosSectoresSocialPrivado.png",
		"formatos": [
			{
				"nombre": "Convenios de Coordinación y Concertación",
				"xlsx": "a69_f33",
				"html": "a69_f33"
			}
		]

	},
	{

		"nombre": "34. Inventario de Bienes",
		"icono": "InventarioBienes.png",
		"formatos": [
			{
				"nombre": "Inventario de Bienes Muebles",
				"xlsx": "a69_f34_a",
				"html": "a69_f34_a"
			},
			{
				"nombre": "Alta de Bienes Muebles",
				"xlsx": "a69_f34_b",
				"html": "a69_f34_b"
			},
			{
				"nombre": "Bajas de Bienes Muebles",
				"xlsx": "a69_f34_c",
				"html": "a69_f34_c"
			},
			{
				"nombre": "Inventario de Bienes Inmuebles",
				"xlsx": "a69_f34_d",
				"html": "a69_f34_d"
			},
			{
				"nombre": "Alta de Bienes Inmuebles",
				"xlsx": "a69_f34_e",
				"html": "a69_f34_e"
			},
			{
				"nombre": "Bajas de Bienes Inmuebles",
				"xlsx": "a69_f34_f",
				"html": "a69_f34_f"
			},
			{
				"nombre": "Donaciones de Bienes Muebles e Inmuebles",
				"xlsx": "a69_f34_g",
				"html": "a69_f34_g"
			}

		]

	},
	{

		"nombre": "35. Recomendaciones y Atención en Materia de Derechos Humanos",
		"icono": "RecomendacionesAtenciónMateriaDerechosHumanos.png",
		"formatos": [
			{
				"nombre": "Recomendaciones de Derechos Humanos Emitidas por la CNDH",
				"xlsx": "a69_f35_a",
				"html": "a69_f35_a"
			},
			{
				"nombre": "Recomendaciones de Derechos Humanos Casos Especiales",
				"xlsx": "a69_f35_b",
				"html": "a69_f35_b"
			},
			{
				"nombre": "Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
				"xlsx": "a69_f35_c",
				"html": "a69_f35_c"
			},
		]

	},
	{

		"nombre": "36. Resoluciones y Laudos de Juicios",
		"icono": "ResolucionesLaudosJuicios.png",
		"formatos": [
			{
				"nombre": " ",
				"xlsx": "",
				"html": "",
				
			}
		],
		"url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/36.%20Resoluciones%20y%20Laudos%20de%20Juicios"

	},
	{

		"nombre": "37. Mecanismo de Participación Ciudadana",
		"icono": "MecanismosParticipacionCiudadana.png",
		"formatos": [
			{
				"nombre": "Mecanismos de Participación Ciudadana",
				"xlsx": "a69_f37_a",
				"html": "a69_f37_a"
			},
			{
				"nombre": "Resultados de los Mecanismos de Participación Ciudadana",
				"xlsx": "a69_f37_b",
				"html": "a69_f37_b"
			}
		]

	},
	{

		"nombre": "38. Programas Ofrecidos",
		"icono": "ProgramasOfrecidos.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			},
			
		],
	
		"url": "https://s-salud.hidalgo.gob.mx/Transparencia/RubrosSsh/DetalleRubroSsh/38.%20Programas%20Ofrecidos"
		

	},
	{

		"nombre": "39. Actas y Resoluciones del Comité de Transparencia",
		"icono": "ActasResolucionesComiteTransparencia.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			},
			
		],
		"url": "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia"

	},
	{

		"nombre": "40. Evaluacion y Encuesta a Programas Financiados con Recursos Públicos",
		"icono": "EvaluacionencuestasProgramas.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			},
			
		],
		"url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/40.Evaluacion%20y%20Encuestas%20a%20Programas%20Financiados%20con%20Recursos%20P%C3%BAblicos"

	},
	{

		"nombre": "41. Estudios Pagados con Recursos Públcos",
		"icono": "EstudiosPagadosRecursosPublicos.png",
		"formatos": [
			{
				"nombre": "Estudios Pagados con Recursos Públicos ",
				"xlsx": "a69_f41",
				"html": "a69_f41"
			}
		]

	},
	{

		"nombre": "42. Listados Jubilados y Pensionados",
		"icono": "ListadoJubiladosPencionados.png",
		"formatos": [
			{
				"nombre": "Jubilados y Pensionados",
				"xlsx": "2024_a69_f42",
				"html": "2024_a69_f42"
			},
			/* {
				"nombre": "Jubilados y Pensionados Listado",
				"xlsx": "f42_b",
				"html": "f42_b"
			} */
		]

	},
	{

		"nombre": "43. Ingresos Recibidos por Cualquier Concepto",
		"icono": "IngresosRecibidosCualquierConcepto.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			},
			
		],
		"url": "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/43.Ingresos%20Recibidos%20por%20Cualquier%20Concepto"

	},
	{

		"nombre": "44. Donaciones Hechas a Terceros",
		"icono": "DonacionesHechasTerceros.png",
		"formatos": [
			{
				"nombre": "Donaciones hechas a Terceros en Dinero y en Especie",
				"xlsx": "2024_a69_f44",
				"html": "2024_a69_f44"
			},
		/* 	{
				"nombre": "Donaciones Hechas a Terceros en Especie",
				"xlsx": "a69_f44_b",
				"html": "a69_f44_b"
			} */
		]

	},
	{

		"nombre": "45. Catálogo Documental y Guia de Archivos",
		"icono": "CatalogoDocumentalGuiaArchivos.png",
		"formatos": [
			{
				"nombre": "Inventarios Documentales",
				"xlsx": "2024_a69_f45_a",
				"html": "2024_a69_f45_a"
			},
			{
				"nombre": "Expedientes Clasificados como Reservados",
				"xlsx": "a69_f45",
				"html": "a69_f45",
		
				"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f45b_SC.xlsx",
				"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm"
		
			},
			{
				"nombre": "Catálogo de Disposición y Guía de Archivos",
				"xlsx": "2024_a69_f45_c",
				"html": "2024_a69_f45_c"
			}
		
		]

	},
	{

		"nombre": "46. Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos",
		"icono": "ActasSesionesOpinionesRecomendacionesConsejosConsultivos.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			},
			
		],
		"url": "https://s-turismo.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/46.Actas%20de%20Sesiones,%20Opiniones%20y%20Recomendaciones%20de%20Consejos%20Consultivos"

	},
	{

		"nombre": "47. Solicitud de Intervención de  Comunicaciones",
		"icono": "SolicitudIntervencionComunicaciones.png",
		"formatos": [
			{
				"nombre": "",
				"xlsx": "",
				"html": ""
			},
			
		],
		"url": "https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervenci%C3%B3n%20de%20%20Comunicaciones"
	
	},
	{

		"nombre": "48. Información de Utilidad o Relevante",
		"icono": "InformacionUtilidadRelevante.png",
		"formatos": [
			{
				"nombre": "Interés Público",
				"xlsx": "a69_f48_a",
				"html": "a69_f48_a"
			},
			{
				"nombre": "Preguntas Frecuentes",
				"xlsx": "a69_f48_b",
				"html": "a69_f48_b"
			},
			{
				"nombre": "Transparencia Proactiva",
				"xlsx": "a69_f48_c",
				"html": "a69_f48_c"
			}
		],
	
	},
]